import { scheduleOnce } from '@ember/runloop';

export default (...args) => scheduleOnce('afterRender', ...args);
